import type { PaperMeta } from "../types";

/** The publisher page of a paper, from its document ID alone. */
export const getExternalUrlFromId = (docId: string): string | null => {
  if (docId.startsWith("bio_")) return "https://www.biorxiv.org/";
  if (docId.startsWith("med_")) return "https://www.medrxiv.org/";
  if (docId.startsWith("arx_") || docId.startsWith("arxiv_")) {
    const arxivId = docId.replace(/^(arxiv|arx)_/, "");
    return `https://arxiv.org/abs/${arxivId}`;
  }
  if (docId.toUpperCase().startsWith("PMC"))
    return `https://www.ncbi.nlm.nih.gov/pmc/articles/${docId}/`;
  if (/^NCT\d{8}$/i.test(docId)) return `https://clinicaltrials.gov/study/${docId.toUpperCase()}`;
  return null;
};

/** The publisher page of a paper, from its metadata. */
export const getOriginalPaperUrl = (meta: PaperMeta, docId: string): string | null => {
  const source = meta.source?.toLowerCase();

  if (source === "arxiv") {
    const arxivId = meta.document_id || docId.replace(/^arx_/, "");
    return `https://arxiv.org/abs/${arxivId}`;
  }

  if (source === "pmc") {
    const pmcId = meta.pmc_id || meta.document_id || docId;
    return `https://www.ncbi.nlm.nih.gov/pmc/articles/${pmcId}/`;
  }

  if (meta.doi) {
    return `https://doi.org/${meta.doi}`;
  }

  if (source === "biorxiv") {
    return `https://www.biorxiv.org/`;
  }

  if (source === "medrxiv") {
    return `https://www.medrxiv.org/`;
  }

  return null;
};
